import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={8}
    height={15}
    viewBox="0 0 8 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.979 14.192V0L.903 7.096z" fill="#0C42B3" />
  </svg>
);
export default SVGComponent;
